export const FONTS = {
    l: 'h2-semibold',
    m: 'h3-semibold',
    s: 'body-semibold-asphalt',
};
//# sourceMappingURL=constants.js.map